import React, { useCallback } from 'react'
import { hooks, ModelForm } from '@front/volcanion'
import { HookUtils } from '@front/volcanion/utils'

import { Loader } from '@front/squirtle'
import Callbacks from './callbacks'

const withForm = Component => props => {
  const { record_id } = props
  const [user_city, user_state] = hooks.useActiveUser({ populate: ['staffinfo'], mutator: 'staffinfo.city' })
  const formProps = {
    name: 'group_form',
    model_name: 'group',
    record_id,
    related_states: [],
    related_searches: [],
    recordToForm: useCallback(Callbacks.recordToFormHandler(), []),
    recordToState: useCallback(Callbacks.recordToStateHandler(), []),
    formToRecord: useCallback(Callbacks.formToRecordHandler(), []),
    getEmptyForm: useCallback(Callbacks.getEmptyFormHandler(user_city), [user_city]),
    populate: [
      'contacts'
    ],
    initialState: { isReadOnly: !!record_id },
    onSubmitSuccess: useCallback(Callbacks.onSubmitSuccessHandler(), []),
    onSubmitFailed: useCallback(Callbacks.onSubmitFailedHandler(), []),
    submitChangesOnly: false
  }

  const mergedProps = {
  }
  return (
    <Loader isLoading={HookUtils.getLoadingState([user_state])}>
      <ModelForm {...formProps}>
        <Component {...mergedProps} />
      </ModelForm>
    </Loader>
  )
}

export default withForm
